import axios from "axios";

import globalRouter from "../../src/components/globalRouter";

const api = axios.create({

    baseURL: (process.env.REACT_APP_API_URL || "__BACKEND_API__") + "/api/v1",
});



export default api

// Rotas públicas (login/recuperação). Um 401 vindo delas é "credencial ou
// token de recuperação inválido", não "sessão expirada" — não pode derrubar
// o usuário pro /login nem virar sucesso silencioso na tela.
const PUBLIC_PATHS = ["/auth/token", "auth/token", "/recovery", "recovery"]

const isPublicPath = (url = "") => PUBLIC_PATHS.some((p) => url.startsWith(p))

const isRecoveryPath = (url = "") => url.startsWith("/recovery") || url.startsWith("recovery")

api.interceptors.response.use((response) => {
    return response
}, function (error) {
    // Erro de rede/timeout/CORS: não há response. Antes estourava um
    // TypeError aqui dentro e mascarava a causa real.
    const status = error.response?.status
    if (!status) {
        return Promise.reject(error)
    }

    const url = error.config?.url || ""

    switch (status) {
        case 401: {
            if (isPublicPath(url)) break

            const detail = error.response?.data?.detail
            // Token revogado pelo backend (logout em outra aba ou admin) → mostrar banner.
            if (detail === "token_revoked") {
                try { sessionStorage.setItem("loginBannerReason", "revoked") } catch {}
            }
            localStorage.removeItem("token")
            globalRouter.navigate('/login')
            break;
        }
        case 429: {
            const detail = error.response?.data?.detail
            // O banner é do /login. Rate limit da recuperação é mostrado na
            // própria tela — senão sobra um aviso solto no login depois.
            if (detail === "rate_limited" && !isRecoveryPath(url)) {
                try { sessionStorage.setItem("loginBannerReason", "rate_limited") } catch {}
            }
            break;
        }
        case 403:
            window.dispatchEvent(new CustomEvent('auth:forbidden', {
                detail: { url: error.config?.url, message: error.response?.data?.detail }
            }))
            break;
        case 402: {
            // Licença expirada ou inválida
            console.warn("🚫 Licença expirada:", error.response?.data?.message);

            // Salva informações da licença para mostrar na página
            const licenseError = {
                message: error.response?.data?.message || "Licença expirada",
                error: error.response?.data?.error || "Licença inválida",
                timestamp: new Date().toISOString(),
                app: error.response?.data?.app || "Sistema"
            };

            localStorage.setItem("licenseError", JSON.stringify(licenseError));

            // Redireciona para página de licença expirada
            globalRouter.navigate('/license-expired');
            break;
        }
        default:
            console.log(error.response)
            break;
    }

    // Sempre rejeita: devolver undefined fazia o axios RESOLVER a promise, e
    // o .then() da página rodava como se a requisição tivesse dado certo.
    return Promise.reject(error)
})


export const get_all = async (endpoint, limit = 10, offset = 0, order_by = undefined, order = undefined, query = "") => {
    const response = await api.post(endpoint, { limit, offset, order_by, order, query })
    return response
}

export const get_one = async (endpoint, id) => {
    const response = await api.get(endpoint + "/" + id)
    return response
}

export const create = async (endpoint, data) => {
    const response = await api.post(endpoint, data)
    return response
}

export const update = async (endpoint, id, data) => {
    const response = await api.put(endpoint + "/" + id, data)
    return response
}

export const delete_one = async (endpoint, id) => {
    const response = await api.delete(endpoint + "/" + id)
    return response
}
